export const PAYMENT = {
  title_payment: "",
  description: "Подвердите оплату, чтобы получить бонус.",
  payload: "invoice",
  currency: "XTR",
};
